export default __webpack_public_path__ + "static/media/upwork.febb7f18.svg";